import { LngLat, LngLatLike } from 'mapbox-gl';

import { SpotterLocation } from '@/common/types';

export const spotterToLngLat = ({ longitude, latitude }: SpotterLocation) => new LngLat(longitude, latitude);

/**
 * Converts anything that looks like a geoposition to a LngLat
 */
export const lngLat = (position: LngLatLike | SpotterLocation): LngLat => {
    if ('longitude' in position) {
        return spotterToLngLat(position);
    }
    return LngLat.convert(position);
};

/**
 * Converts anything that looks like a geoposition to a [lng, lat] array suitable for turf
 * @returns [lng, lat]:[number, number]
 */
export const lngLatToTurf = (position: LngLatLike | SpotterLocation) => lngLat(position).toArray();

export const locationForTrackingMetrics = (position?: LngLatLike | SpotterLocation | null) => {
    if (!position) return null;

    const { lat, lng } = lngLat(position);
    // rounding both to make the number not overwhelming to human metric dashboard consumers, and to anonymize
    // it enough that we can't tell exactly where anyone's looking.
    return { lat: Math.round(lat), lng: Math.round(lng) };
};
